interface Route {
  initiative: string;
  profile: string;
}

const routes: Route = {
  initiative: 'workspace.spaceSettings.teams',
  profile: 'workspace.spaceSettings.account',
};

const generateSettingsLink = (spaceType: keyof Route) => routes[spaceType];

export default generateSettingsLink;
